export const roofReducers = {
  /**
   * Sets the roof type.
   * @param {Object} state - The current state.
   * @param {Object} action - The action object.
   * @param {string} action.payload - The new roof type ('slope' or 'aframe').
   */
  setRoofType: (state: any, action: any) => {
    if (state.roofType !== action.payload)
      state.roofSlopeOrientation = action.payload === 'aframe' ? 'vertical' : 'slopeRight';
    state.roofType = action.payload;
  },

  /**
   * Sets the roof slope orientation.
   * @param {Object} state - The current state.
   * @param {Object} action - The action object.
   * @param {string} action.payload - The new roof slope orientation.
   */
  setRoofSlopeOrientation: (state: any, action: any) => {
    state.roofSlopeOrientation = action.payload;
  },

  /**
   * Sets the roof height.
   * @param {Object} state - The current state.
   * @param {Object} action - The action object.
   * @param {Object} action.payload - The new roof height.
   * @param {number} [action.payload.min] - The minimum roof height.
   * @param {number} [action.payload.max] - The maximum roof height.
   */
  setRoofHeight: (state: any, action: any) => {
    const { min, max } = action.payload;
    const { min: currentMin, max: currentMax } = state.roofHeight;
    // NOTE: this might get simplified if we check in middleware
    state.roofHeight = {
      min: min ? min : (!max || currentMin < max) ? currentMin : max,
      max: max ? max : (!min || currentMax > min) ? currentMax : min || 0
    }
  },

  /**
   * Toggles the roof grid.
   * @param {Object} state - The current state.
   */
  setRoofGrid: (state: any, action: any) => {
    state.roofGrid = !state.roofGrid
  },

  setRoofGridSpacing: (state: any, action: any) => {
    const { x, y } = action.payload;
    const { x: currentX, y: currentY } = state.roofGridSpacing;
    state.roofGridSpacing = {
      x: x || currentX,
      y: y || currentY,
    };
  },

  /**
   * Sets the roof grid offset.
   * @param {Object} state - The current state.
   * @param {Object} action - The action object.
   * @param {Object} action.payload - The new roof grid offset.
   * @param {number} [action.payload.dx] - The x-axis offset.
   * @param {number} [action.payload.dy] - The y-axis offset.
   */
  setRoofGridOffset: (state: any, action: any) => {
    const { dx, dy } = action.payload;
    const { dx: currentDx, dy: currentDy } = state.roofGridOffset;
    const { x, y } = state.roofGridSpacing;
    state.roofGridOffset = {
      dx: dx !== undefined ? dx > x ? dx % x : dx : currentDx,
      dy: dy !== undefined ? dy > y ? dy % y : dy : currentDy,
    };
  },
};
